<template>
<el-menu
    :default-active="this.$route.path"
    class="head"
    mode="horizontal"
    :ellipsis="false"
    router
  >
    <img src="https://static.igem.wiki/teams/5298/assets/logo.png" style="width:8vw"/>
    <img src="https://static.igem.wiki/teams/5298/assets/transparent.png" style="width:5vw"/>
    <el-menu-item class="menuitem" index="/">
        <template #default><div class="menuitem"><span class="iconfont icon-zhuye" style="font-size:22px;"></span>Home</div></template>
    </el-menu-item>
    <el-sub-menu index="2" class="menuitem">
      <template #title><div class="menuitem"><el-icon><Document /></el-icon>Project</div></template>
      <el-menu-item class="submenuitem" index="/description">Description</el-menu-item>
      <el-menu-item class="submenuitem" index="/design">Design</el-menu-item>
      <el-menu-item class="submenuitem" index="/proof-of-concept">Proof of Concept</el-menu-item>
      <el-menu-item class="submenuitem" index="/implementation">Implementation</el-menu-item>
      <el-menu-item class="submenuitem" index="/futurework">Future Work</el-menu-item>
      <el-menu-item class="submenuitem" index="/contribution">Contribution</el-menu-item>
    </el-sub-menu>
    <el-sub-menu index="3" class="menuitem">
      <template #title><div class="menuitem"><span class="iconfont icon-wrench" style="font-size:22px;"></span>Wet Lab</div></template>
      <el-menu-item class="submenuitem" index="/notebook">Notebook</el-menu-item>
      <el-menu-item class="submenuitem" index="/engineering">Engineering</el-menu-item>
      <el-menu-item class="submenuitem" index="/protocol">Protocol</el-menu-item>
      <el-menu-item class="submenuitem" index="/results">Results</el-menu-item>
      <el-menu-item class="submenuitem" index="/parts">Parts</el-menu-item>
    </el-sub-menu>
    <el-menu-item class="menuitem" index="/model"><el-icon><Setting /></el-icon>Model</el-menu-item>
     <el-sub-menu index="5" class="menuitem">
      <template #title><div class="menuitem"><span class="iconfont icon-liaotian_icon" style="font-size:17px;font-weight: bold"></span>HP</div></template>
      <el-menu-item class="submenuitem" index="/human-practices">Integrated Human Practice</el-menu-item>
      <el-menu-item class="submenuitem" index="/entrepreneurship">Entrepreneurship</el-menu-item>
      <el-menu-item class="submenuitem" index="/education">Education</el-menu-item>
    </el-sub-menu>
    <el-menu-item class="menuitem" index="/safety"><span class="iconfont icon-shielddunpai" style="font-size:20px;"></span>Safety</el-menu-item>
    <el-sub-menu index="7" class="menuitem">
      <template #title><div class="menuitem"><span class="iconfont icon-tuandui" style="font-size:22px;"></span>Team</div></template>
      <el-menu-item class="submenuitem" index="/team">Roster</el-menu-item>
      <el-menu-item class="submenuitem" index="/attributions">Attributions</el-menu-item>
    </el-sub-menu>
  </el-menu>
</template>

<script setup>


</script>

<style lang="less" scopde>
    .head {
        --el-menu-hover-text-color: #DB6AA8;
        --el-menu-hover-bg-color: rgb(255,255,255,30%);
        --el-menu-active-color: #DB6AA8;
        --el-menu-item-font-size: 25px;
        position:fixed;
        width:100%;
        height:6.5vh;
        position: relative;
        display: flex;
        justify-content: center;
        z-index: 999;
        background-color: #E3DCEC;
        border-radius: 15px;
    }

    .menuitem{
        width:10vw;
        text-align: center;
        font-family:Arial, Helvetica, sans-serif;
        font-weight: 500;
        letter-spacing: 1px;
    }

    .submenuitem{
        --el-menu-hover-text-color: #DB6AA8;
        --el-menu-active-color: #DB6AA8;
        --el-menu-hover-bg-color: rgb(227,220,236,30%);
        --el-menu-item-font-size: 20px;
        font-family:Arial, Helvetica, sans-serif;
        font-weight: bold;
        letter-spacing: 1px;
    }

    .iconfont{
      margin-right: 5px;
    }
    
</style>